import { PaginatedRequestParams } from "api";
import { Dayjs } from "dayjs";

export enum EntryLogFilterFormField {
  Date = 'date',
  DriverName = 'DriverName',
  SupplierName = 'SupplierName',
  VehicleNumber = 'VehicleNumber',
  EntryTypeId = 'EntryTypeId',
  StatusId = "StatusId",
  Date1 = "date1"
}
export enum LodingLogFilterFormField {
  Date = 'date',
  DriverName = 'DriverName',
  SupplierName = 'SupplierName',
  VehicleNumber = 'VehicleNumber',
}

export type EntryLogFilterFormValues = {
  [EntryLogFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [EntryLogFilterFormField.DriverName]: string | undefined;
  [EntryLogFilterFormField.SupplierName]: string | undefined;
  [EntryLogFilterFormField.VehicleNumber]: string | undefined;
  [EntryLogFilterFormField.EntryTypeId]: string | undefined;
  [EntryLogFilterFormField.StatusId]: string | undefined;
  [EntryLogFilterFormField.Date1]: [Dayjs | undefined, Dayjs | undefined] | null;

};
export type EntryLogFilterFormValuesPaginated = EntryLogFilterFormValues &
  PaginatedRequestParams;
export type VehicleFilterFormValues = {
  [EntryLogFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [EntryLogFilterFormField.DriverName]: string | undefined;
  [EntryLogFilterFormField.SupplierName]: string | undefined;
  [EntryLogFilterFormField.VehicleNumber]: string | undefined;
};
export type LodingLogFilterFormValues = {
  [LodingLogFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [LodingLogFilterFormField.DriverName]: string | undefined;
  [LodingLogFilterFormField.SupplierName]: string | undefined;
  [LodingLogFilterFormField.VehicleNumber]: string | undefined;
};
export type VehicleFilterFormValuesPaginated = EntryLogFilterFormValues &
  PaginatedRequestParams;
export type LodingFilterFormValuesPaginated = LodingLogFilterFormValues &
  PaginatedRequestParams;